<modal-panel [title]="title" data-testid="trip-reference-modal-panel" (close)="closeDialog()" >
  <ng-container data-testid="trip-reference-modal-container">
    <trip-reference-details [data]="data.travelServiceId"></trip-reference-details>
  </ng-container>

  <ng-container data-testid="trip-reference-modal-footer" modalPanelFooter >
    <button data-testid="trip-reference-modal-close-button" mat-raised-button color="primary" 
      (click)="closeDialog()">Close</button>
  </ng-container>